import UnicommerceLogo from '../../../../assets/image/Channels/unicommerce.png'
import Amazon from '../../../../assets/image/Channels/Amazon.png'
import MagentoChannel from '../../../../assets/image/Channels/MagentoChannel.png'
import clickPost from '../../../../assets/image/Channels/clickpost.png'

const ChannelData = [
    {
        "id": 6,
        "created_at": "2024-12-16T10:15:38.426725+05:30",
        "updated_at": "2024-12-16T10:15:38.426725+05:30",
        "image": MagentoChannel,
        "link": "https://linkedin.com/",
        "status": true,
        "position": 4,
        "name": "Magento",
        "created_by": null,
        "updated_by": null
    },
    {
        "id": 5,
        "created_at": "2024-12-16T10:15:38.426725+05:30",
        "updated_at": "2024-12-16T10:15:38.426725+05:30",
        "image": Amazon,
        "link": "https://linkedin.com/",
        "status": true,
        "position": 5,
        "name": "Amazon",
        "created_by": null,
        "updated_by": null
    },
    {
        "id": 4,
        "created_at": "2024-12-16T10:15:38.426725+05:30",
        "updated_at": "2024-12-16T10:15:38.426725+05:30",
        "image": "https://shipease-dev.s3.amazonaws.com/admin/627-200px600px-Color[1].png",
        "link": "https://linkedin.com/",
        "status": true,
        "position": 6,
        "name": "Store Hippo",
        "created_by": null,
        "updated_by": null
    },
    {
        "id": 3,
        "created_at": "2024-12-16T10:13:47.217429+05:30",
        "updated_at": "2024-12-16T10:13:47.217429+05:30",
        "image": UnicommerceLogo,
        "link": "https://linkedin.com/",
        "status": true,
        "position": 3,
        "name": "Unicommerce",
        "created_by": null,
        "updated_by": null
    },
    {
        "id": 2,
        "created_at": "2024-12-16T10:12:10.009013+05:30",
        "updated_at": "2024-12-16T10:12:10.009013+05:30",
        "image": clickPost,
        "link": "https://linkedin.com/",
        "status": true,
        "position": 2,
        "name": "ClickPost",
        "created_by": null,
        "updated_by": null
    },
    {
        "id": 1,
        "created_at": "2024-12-16T10:09:05.986830+05:30",
        "updated_at": "2024-12-16T10:09:05.986830+05:30",
        "image": "https://shipease-dev.s3.amazonaws.com/admin/1280px-Shopify_logo_2018.svg[1].png",
        "link": "https://linkedin.com/",
        "status": true,
        "position": 1,
        "name": "Shopify",
        "created_by": null,
        "updated_by": null
    }
];

export default ChannelData;